const saveExaustorState = async (exaustorState) => {
    const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/saveStatus`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ exaustorState }),
    });
    return response.json();
};

export default saveExaustorState;